import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Plane, Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Ceva nu a mers bine. Încearcă din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-stone-900 flex items-center justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-stone-400 hover:text-white text-sm mb-8" data-testid="back-home">
          <ArrowLeft className="h-4 w-4" /> Înapoi la site
        </Link>
        <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-2xl">
          <div className="flex items-center gap-2 mb-8">
            <span className="grid place-items-center h-10 w-10 rounded-xl bg-sky-700 text-white"><Plane className="h-5 w-5 -rotate-45" /></span>
            <span className="font-head font-extrabold text-2xl tracking-tight text-stone-900">Zbor<span className="text-sky-700">Help</span></span>
          </div>
          <h1 className="font-head font-bold text-2xl text-stone-900 flex items-center gap-2"><Lock className="h-5 w-5 text-sky-700" /> Admin</h1>
          <p className="text-stone-500 mt-2 text-sm">Autentificare panou administrare</p>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div className="space-y-2">
              <Label className="text-sm font-medium text-stone-700">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="h-12" required />
            </div>
            <div className="space-y-2">
              <Label className="text-sm font-medium text-stone-700">Parolă</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="h-12" required />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full h-12 bg-sky-700 hover:bg-sky-800 text-white font-bold rounded-full">
              {loading ? "Se conectează..." : "Conectare"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
